import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import { queryKeys } from './useAuctions';
import type { AuctionDetail } from '@/types/domain';

export function useConfirmDeal(auctionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.confirmDeal(auctionId),
    onSuccess: (updated: AuctionDetail) => {
      // Кладём свежую деталку в кэш — UI сразу перерисуется
      qc.setQueryData(queryKeys.auction(auctionId), updated);
    },
  });
}

export function useRefuseDeal(auctionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (description: string | null) =>
      api.refuseDeal(auctionId, description),
    onSuccess: () => {
      // После отказа состояние меняется (заморозка) — перечитаем деталку
      qc.invalidateQueries({ queryKey: queryKeys.auction(auctionId) });
    },
  });
}